import { LoadingButton } from "@mui/lab";
import { styled } from "@mui/material";

export const ErrorText = styled('div')({
    fontSize: "12px",
    color: 'red'
});
  
export const MandatoryStarWrapper = styled("span")({
    color: "red"
})

export const PageWrapper = styled("div")(() => `
    padding: 27px;
    min-height: calc(100vh - 57px - 55px); // 100vh - footer height - header height
    background: #ffffff;
`)

export const MidContainer = styled("div")(() => `
    margin: 0 auto;
    max-width: 1450px;
    width: 100%;
`)


export const PageTitle = styled("h1")(() => `
    font-weight: 700;
    font-size: 24px;
    line-height: 112.2%;
    color: #000000;
    margin: 0;
`)

export const PageSubTitle = styled("h2")(() => `
    font-weight: 700;
    font-size: 18px;
    line-height: 112.2%;
    color: #000000;
    margin: 0;
    margin-bottom: 20px;
`)

export const PageDescription = styled("p")(() => `
    font-weight: 400;
    font-size: 16px;
    line-height: 112.2%;
    color: #424242;
    margin: 0;
`)

export const PageTopSection = styled("div")(() => `
    display: flex;
    flex-direction: column;
    gap: 8px;
`)

export const LoadingBtn = styled(LoadingButton)(
    () => `
      padding: 0.72em 1.29em;
      background: #EB0A1E;
      border-radius: 4px;
      border: none;
      outline: none;
      font-size: clamp(14px, 0.9vw, 30px);
      font-weight: bold;
      line-height: 112.2%;
      color: white;
      display: flex;
      align-items: center;
      cursor: pointer;
      display: flex;
      gap: 5px;
      font-family: 'Toyota';
      &.Mui-disabled {
        opacity: 0.6;
      }
      &:hover {
        background: #EE2F40;
    }
    & span.MuiLoadingButton-loadingIndicator {
        color: white;
        position: relative;
        transform: none;
        left: 0;
    }
        &.Mui-disabled {
            font-size: clamp(14px, 0.9vw, 30px);
            font-weight: bold;
            line-height: 112.2%;
            color: white;
            display: flex;
            align-items: center;
            cursor: pointer;
            display: flex;
            gap: 5px;
            font-family: 'Toyota';
        }
    `
);
